/* Delegation supports cards appended by search, map and portal pages. */
const galleries = new WeakMap();
function enhance(scope) {
  scope.querySelectorAll('[data-mx-card-photos]').forEach(el => { el.hidden = false; });
}
enhance(document);
new MutationObserver(records => {
  for (const record of records) for (const node of record.addedNodes) {
    if (node instanceof Element) enhance(node);
  }
}).observe(document.body, { childList: true, subtree: true });

document.addEventListener('click', async event => {
  const button = event.target.closest('[data-mx-photo-step]');
  if (!button) return;
  event.preventDefault();
  const controls = button.closest('[data-mx-card-photos]');
  const image = controls.parentElement.querySelector('.mx-card__img');
  const status = controls.querySelector('[data-mx-photo-status]');
  if (!image || controls.dataset.busy) return;
  controls.dataset.busy = 'true';
  controls.setAttribute('aria-busy', 'true');
  try {
    let gallery = galleries.get(controls);
    if (!gallery) {
      const response = await fetch(controls.dataset.mxCardPhotos, { credentials: 'same-origin' });
      if (!response.ok) throw new Error('Photos unavailable');
      const photos = await response.json();
      if (!Array.isArray(photos) || photos.length < 2) throw new Error('Photos unavailable');
      gallery = { photos, index: 0 };
      galleries.set(controls, gallery);
    }
    const next = (gallery.index + Number(button.dataset.mxPhotoStep) + gallery.photos.length) % gallery.photos.length;
    const photo = gallery.photos[next];
    const loaded = new Image();
    loaded.sizes = image.sizes;
    loaded.srcset = photo.srcset;
    loaded.src = photo.src;
    await loaded.decode();
    image.srcset = photo.srcset;
    image.src = photo.src;
    gallery.index = next;
    status.textContent = 'Photo ' + (next + 1) + ' of ' + gallery.photos.length;
  } catch {
    status.textContent = 'Photo could not load. Please try again.';
  } finally {
    delete controls.dataset.busy;
    controls.removeAttribute('aria-busy');
  }
});
